import {ProductPropertyValueInterface} from "../../interfaces/product/ProductPropertyValueInterface";
import {Link} from "react-router-dom";
import {CategoryInterface} from "../../interfaces/catalog/CategoryInterface";

interface PropertyTableProps {
    properties: ProductPropertyValueInterface[];
    parentCategory?: CategoryInterface;
}

export default function PropertyTable({properties, parentCategory}: PropertyTableProps) {
    return (
        <table className="table table-striped w-100">
            <tbody>
            {properties.map((property: ProductPropertyValueInterface) => (
                <tr key={property.id}>
                    <td className="">{property.name}</td>
                    <td className={'text-end'}>
                        {property.is_link && parentCategory ? (
                            <Link
                                to={`/catalog/list/${parentCategory.catalog_code}/${parentCategory.human_url}?filters=f${property.id}%3A${property.value}`}
                                className="pointer text-orange"
                            >
                                {property.value}
                            </Link>
                        ) : (
                            property.value
                        )}
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    );
}